import "../../App.css";
import "../../styling/VideoGallery.css";

import Carousel from "react-bootstrap/Carousel";

function VideoGallery() {
  return (
    <Carousel fade wrap style={{ marginBottom: "5vh" }}>
      <Carousel.Item>
        <div style={{ padding: 15 }}>
          <iframe
            src="https://player.vimeo.com/video/1076230704?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title="MARCH 2025  EVENT RECAP"
          ></iframe>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ padding: 15 }}>
          <iframe
            src="https://player.vimeo.com/video/1083278128?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title="December 2024 Recap"
          ></iframe>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ padding: 15 }}>
          <iframe
            src="https://player.vimeo.com/video/1007452863?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            title="THAT SHOW (on April 27, 2024)"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </Carousel.Item>
    </Carousel>
  );
}

export default VideoGallery;
